// Initialize Supabase FIRST before any other imports that might use it
import {
  getSupabaseAnonKey,
  getSupabaseUrl,
  initI18n,
  initializeSupabase,
} from '@lumora/common';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';
import { addResourceHints } from './utils/cache';
import './config/env';
import './polyfills';
import './styles/globals.css';
import {
  initializePerformanceTracking,
  trackPageLoad,
} from './utils/performance';
import { registerServiceWorker } from './utils/serviceWorker';

initializeSupabase(getSupabaseUrl(), getSupabaseAnonKey());

// Initialize i18n
initI18n();

async function initApp() {
  // Initialize performance tracking
  initializePerformanceTracking();

  // Track initial page load
  trackPageLoad('APP_INIT');

  // Note: sessionManager is initialized by AuthProvider, not here
  // Removed sessionManager.initialize() as it was causing hangs with persistSession: false

  // Add resource hints for better performance
  addResourceHints();

  // Preload critical resources (disabled - API endpoints not implemented)
  // preloadCriticalResources();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // Register service worker for offline functionality
  if (import.meta.env.PROD) {
    registerServiceWorker({
      onSuccess: () => {
        console.log('App is ready for offline use');
      },
      onUpdate: _registration => {
        console.log('New version available');
        // Could show a toast notification here
      },
      onOfflineReady: () => {
        console.log('App is ready to work offline');
      },
    });
  }
}

initApp();
